module.exports = __webpack_public_path__ + "img/anxz.16994b4d.png";